import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FiCalendar, FiHome, FiLogOut, FiUser, FiMessageSquare } from "react-icons/fi";
import { PiDog } from "react-icons/pi";
import { GiConfirmed } from "react-icons/gi";
import { OwnerContext } from "../../context/OwnerContext";
import LanguageSwitcher from '../commons/LanguageSwitcher';
import '../../styles/MobileSidebar.css';

const MobileOwnerSidebar = () => {
    const navigate = useNavigate();
    const { t } = useTranslation('common');
    const { owner } = useContext(OwnerContext);

    // Same display name logic as in OwnerSidebar
    const displayName = owner?.firstName && owner?.lastName
        ? `${owner.firstName} ${owner.lastName}`
        : owner?.username || 'Owner';

    const handleLogout = () => {
        // Clean up authentication
        localStorage.removeItem('jwt');
        localStorage.removeItem('refreshToken');

        // Close the mobile sidebar and remove backdrop (same logic as navigateTo)
        const mobileSidebar = document.querySelector('.mobile-sidebar');
        const backdrop = document.querySelector('.sidebar-backdrop');

        if (mobileSidebar) {
            mobileSidebar.classList.remove('open');
        }

        if (backdrop) {
            backdrop.remove();
        }

        // Navigate to home page
        navigate('/');
    };

    const navigateTo = (path) => {
        navigate(path);
        // Find and close the sidebar
        const mobileSidebar = document.querySelector('.mobile-sidebar');
        const backdrop = document.querySelector('.sidebar-backdrop');

        if (mobileSidebar) {
            mobileSidebar.classList.remove('open');
        }

        if (backdrop) {
            backdrop.remove();
        }
    };

    return (
        <>
            {/* Mobile Sidebar - no hamburger button here anymore */}
            <div className="mobile-sidebar">
                <div className="profile-section">
                    <div className="profile-icon">
                        <span>{displayName.charAt(0)}</span>
                    </div>
                    <p>{displayName}</p>
                </div>

                <nav className="nav-section">
                    <ul>
                        <li>
                            <button className="nav-button" onClick={() => navigateTo('/owner/dashboard')}>
                                <FiHome /> {t('sidebar.dashboard')}
                            </button>
                        </li>
                        <li>
                            <button className="nav-button" onClick={() => navigateTo('/owner/my-dog')} data-onboarding="my-dog">
                                <PiDog /> {t('sidebar.myDog')}
                            </button>
                        </li>
                        <li>
                            <button className="nav-button" onClick={() => navigateTo('/owner/trainings')}>
                                <GiConfirmed /> {t('sidebar.myTrainings')}
                            </button>
                        </li>
                        <li>
                            <button className="nav-button" onClick={() => navigateTo('/owner/calendar')} data-onboarding="calendar">
                                <FiCalendar /> {t('sidebar.calendar')}
                            </button>
                        </li>
                        <li>
                            <button className="nav-button" onClick={() => navigateTo('/owner/chat')}>
                                <FiMessageSquare /> {t('sidebar.chat')}
                            </button>
                        </li>
                        <li>
                            <button className="nav-button" onClick={() => navigateTo('/owner/account')} data-onboarding="my-account">
                                <FiUser /> {t('sidebar.myAccount')}
                            </button>
                        </li>
                    </ul>
                </nav>

                <LanguageSwitcher variant="sidebar" />
                <button className="logout-button" onClick={handleLogout}>
                    <FiLogOut className="logout-icon" /> {t('sidebar.logout')}
                </button>
            </div>
        </>
    );
};

export default MobileOwnerSidebar;